import AspectRatio from 'components/atoms/AspectRatio';
import styled from 'styled-components';
import { Row, Col } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import Link from 'components/atoms/Link';
import Cartola from 'components/molecules/Cartola';
import { render } from 'storyblok-rich-text-react-renderer';
import Colors from 'components/tokens/Colors';
import { colaboratorsFormatter } from 'helpers/colaboratorNameFormatter';
import { getAssetURL } from 'helpers/getAssetURL';
import { getHat } from 'helpers/getHat';
import getNewsUrl from 'helpers/getNewsUrl';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import placeholder from 'assets/image_placeholder.png';

const HorizontalContentText = ({ data, reverse }) => {
    const authors = data?.content?.authors;
    const { isStoryblokEditor } = useEditor();

    const descriptionContent = () => {
        return (
            <Row>
                <Col size="12">
                    <StyledText size="16" lineHeight="22">
                        {data?.content?.resume && render(data?.content?.resume)}
                    </StyledText>
                </Col>
                <Col size="12">
                    <Row mt="3" justifyContent="space-between">
                        {authors?.length > 0 && (
                            <Col size="auto">
                                <Text body2 color={Colors.grey}>
                                    {colaboratorsFormatter(authors, true)}
                                </Text>
                            </Col>
                        )}

                        <Col size="auto">
                            <Link href={getNewsUrl(data.full_slug, data.first_published_at)}>Leia mais</Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    };

    return (
        <Container>
            <Row justifyContent="space-between" alignItems="center">
                <Col order={`0 ${reverse ? 1 : 0}`} size="12 6">
                    <Row>
                        <Col size="auto" mt="3" mb="1 0">
                            <RouterLink
                                to={getNewsUrl(data.full_slug, data.first_published_at)}
                                editor={isStoryblokEditor}
                                decoration="none"
                                weight="normal"
                            >
                                <Cartola value={getHat(data?.content?.hat, data?.content?.custom_hat)} />
                            </RouterLink>
                        </Col>
                    </Row>
                    <RouterLink
                        to={getNewsUrl(data.full_slug, data.first_published_at)}
                        editor={isStoryblokEditor}
                        decoration="none"
                        weight="normal"
                    >
                        <Row>
                            <Col size="hidden 12" mt="3" mb="2">
                                <Text size="16 40" lineHeight="20 38" title hover>
                                    {data?.content?.featured_title?.replace('#Verificamos:', '') ||
                                        data?.name?.replace('#Verificamos:', '')}
                                </Text>
                            </Col>
                            <Col size="hidden 12">{descriptionContent()}</Col>
                        </Row>
                    </RouterLink>
                </Col>
                <Col order={`0 ${reverse ? 0 : 1}`} size="12 6">
                    <RouterLink
                        to={getNewsUrl(data.full_slug, data.first_published_at)}
                        editor={isStoryblokEditor}
                        decoration="none"
                        weight="normal"
                    >
                        <AspectRatio
                            ratioMobile="55"
                            ratio="60"
                            bg={getAssetURL(data.content?.featured_image?.filename) || placeholder}
                            cursor="pointer"
                        />
                    </RouterLink>
                </Col>
                <RouterLink
                    to={getNewsUrl(data.full_slug, data.first_published_at)}
                    editor={isStoryblokEditor}
                    decoration="none"
                    weight="normal"
                >
                    <Col size="12 hidden" mt="3">
                        <Text body2 highlight hover>
                            {data?.content?.featured_title?.replace('#Verificamos:', '') ||
                                data?.name?.replace('#Verificamos:', '')}
                        </Text>
                    </Col>
                    <Col mt="2" size="12 hidden">
                        <Text size="16" lineHeight="22" color={Colors.grey}>
                            {descriptionContent()}
                        </Text>
                    </Col>
                </RouterLink>
            </Row>
        </Container>
    );
};

const StyledText = styled(Text)`
    a {
        color: black;
        text-decoration: none;
    }

    a:hover {
        color: black;
        text-decoration: none;
    }
`;

const Container = styled.div`
    float: left;
    width: 100%;
`;

export default HorizontalContentText;
